import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { PassengerAudit, PassengerSkeleton } from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-passenger-audit-list',
  templateUrl: './person-profile-passenger-audit-list.component.html',
  styleUrls: ['./person-profile-passenger-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfilePassengerAuditListComponent implements OnInit {
  @Input() passenger: PassengerSkeleton;
  @Input() loading: boolean;
  @Input() passengerAudits: PassengerAudit[];

  @Output() loadPassengerAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadPassengerAudits.emit(this.passenger.passengerId);
  }

  onNextPage() {
    this.nextPage.emit(this.passenger.passengerId);
  }
}
